import { UserType } from '../../entities';
import { AppSecurityRight, ConfigurationSecurityRight, CrmSecurityRight, DashboardSecurityRight, JobSecurityModule, JobSecurityRight, SchedulerSecurityRight } from '../modules';
import { SecurityRole, SecurityRoleType } from '../security.role';

export class EmployeeScheduler implements SecurityRole {

    _id = 'ef7f0f4b-815f-41eb-82d8-eae947284de9';
    system = true;
    hidden = false;
    name = SecurityRoleType.EmployeeScheduler;
    type = UserType.Employee;
    description = 'Can manage customers, manage jobs and schedule';
    rights = [
        AppSecurityRight.LoginWeb,

        SchedulerSecurityRight.CanAccess,
        SchedulerSecurityRight.ManageAppointments,
        SchedulerSecurityRight.ManageRunSheets,
        SchedulerSecurityRight.ManageOtherUserResourceGroups,
        SchedulerSecurityRight.ManageFieldAllocations,

        ConfigurationSecurityRight.AccessMetadata,
        ConfigurationSecurityRight.AccessPricing,
        ConfigurationSecurityRight.AccessTemplates,

        ConfigurationSecurityRight.ManageMetadata,
        ConfigurationSecurityRight.ManagePricing,
        ConfigurationSecurityRight.ManageTemplates,

        ...new JobSecurityModule().allExceptRights([JobSecurityRight.ModifyJobAfterFinalise, JobSecurityRight.ReverseWorkOrderStatus, JobSecurityRight.AccessQuote, JobSecurityRight.ManageQuote, JobSecurityRight.ModifyLockedItems]),

        CrmSecurityRight.CanAccess,
        CrmSecurityRight.ManageEmployees,

        // DashboardSecurityRight.CanViewSystemDashboards,
        DashboardSecurityRight.CanCreateDashboards,

    ];
}

